"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

var _Icons = require("../Icons");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VisualCheckbox = _styledComponents.default.div.withConfig({
  displayName: "VisualCheckbox",
  componentId: "sc-1o4c53d-0"
})(["display:inline-block;width:20px;height:20px;position:relative;top:4px;color:", ";background:", ";border:1px solid ", ";box-sizing:border-box;border-radius:4px;margin-right:8px;cursor:pointer;svg{position:absolute;top:0;left:0;width:18px;height:18px;}", " ", ""], (0, _helpers.color)('white'), (0, _helpers.color)('white'), (0, _helpers.color)('dark-4'), function (p) {
  return (p.checked || p.indeterminate) && (0, _styledComponents.css)(["background:", ";border-color:", ";"], (0, _helpers.color)('primary100'), (0, _helpers.color)('primary100'));
}, function (p) {
  return p.disabled && (0, _styledComponents.css)(["cursor:default;border-color:", ";background:", ";", ""], (0, _helpers.color)('statusUnknown'), (0, _helpers.color)('light-3'), (p.checked || p.indeterminate) && (0, _styledComponents.css)(["border-color:", ";background:", ";"], (0, _helpers.color)('primary60'), (0, _helpers.color)('primary60')));
});

var RawCheckbox = _styledComponents.default.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "RawCheckbox",
  componentId: "sc-1o4c53d-1"
})(["border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;"]);

var CheckboxWrapper = function CheckboxWrapper(_ref) {
  var checked = _ref.checked,
      indeterminate = _ref.indeterminate,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["checked", "indeterminate", "disabled"]);

  return React.createElement(React.Fragment, null, React.createElement(RawCheckbox, _extends({
    checked: checked,
    indeterminate: indeterminate,
    disabled: disabled
  }, props)), React.createElement(VisualCheckbox, {
    checked: checked,
    indeterminate: indeterminate,
    disabled: disabled
  }, indeterminate && !checked && React.createElement(_Icons.MinusIcon, null), checked && React.createElement(_Icons.TickIcon, null)));
};

var Checkbox = (0, _styledComponents.default)(CheckboxWrapper).withConfig({
  displayName: "Checkbox",
  componentId: "sc-1o4c53d-2"
})(["display:inline-block;vertical-align:middle;", ":focus + &{outline:2px solid ", ";outline-offset:2px;}", ""], RawCheckbox, (0, _helpers.color)('neutral-4'), function (p) {
  return !p.disabled && (0, _styledComponents.css)(["", ":active + &{border-color:", ";", "}"], RawCheckbox, (0, _helpers.color)('black'), (p.checked || p.indeterminate) && (0, _styledComponents.css)(["background:", ";"], (0, _helpers.color)('black')));
});
var _default = Checkbox;
exports.default = _default;